import styled from 'styled-components'
import { giphyBlack, giphyDarkGrey, giphyGreen } from '@giphy/colors'
import { ComponentProps, useState } from 'react'

const CheckboxContainer = styled.span`
    background: ${giphyBlack};
    border: 3px solid ${giphyDarkGrey};
    overflow: hidden;
    box-sizing: border-box;
    display: inline-block;
    height: 24px;
    line-height: 22px;
    position: relative;
    text-align: center;
    vertical-align: middle;
    width: 24px;
    z-index: 1;
    input[type='checkbox'] {
        height: 100%;
        left: 0;
        margin: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        width: 100%;
        cursor: pointer;
    }
`

const CheckboxIcon = styled.span`
    color: ${giphyGreen};
    font-size: 14px;
    height: 14px;
    left: 50%;
    margin: -9px 0 0 -6px;
    position: absolute;
    top: 50%;
    width: 14px;
    pointer-events: none;
`

const Checkbox = ({ className = '', ...props }: ComponentProps<'input'>) => {
    const [isChecked, setChecked] = useState(props.checked)
    return (
        <CheckboxContainer className={className}>
            <input
                type="checkbox"
                {...props}
                checked={isChecked}
                onChange={(e) => {
                    setChecked(e.target.checked)
                    props.onChange?.(e)
                }}
            />
            {isChecked && <CheckboxIcon className="ss-check" />}
        </CheckboxContainer>
    )
}

export default Checkbox
